import { ArrowLeft, Play } from "lucide-react";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useState } from "react";

import { useNavigate } from "react-router-dom";

import { airtimeApi } from "../api";

import AirtimeBatchTable from "../components/AirtimeBatchTable";

import AirtimeLoader from "../components/AirtimeLoader";

import { useAirtimeBatches } from "../hooks";
import { useToast } from "#/components/common/ToastProvider";

export default function AirtimeBatchesPage() {

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const toast = useToast();

  const [page, setPage] = useState(0);

  const [size, setSize] = useState(10);

  const { data, isLoading, isFetching } = useAirtimeBatches({ page, size });

  const mutation = useMutation({

    mutationFn: airtimeApi.runDisbursement,

    onSuccess: () => {

      queryClient.invalidateQueries({ queryKey: ["airtime", "batches"] });

      queryClient.invalidateQueries({ queryKey: ["airtime", "stats"] });

      toast.success("Disbursement started successfully");

    },

  });

  if (isLoading) return <AirtimeLoader />;

  return (

    <div className="min-h-screen bg-slate-50 p-6">

      <div className="mb-6 flex flex-col justify-between gap-4 xl:flex-row xl:items-center">

        <div>

          <button

            type="button"

            onClick={() => navigate("/hr/airtime")}

            className="mb-3 inline-flex items-center gap-2 text-sm font-black text-emerald-700"

          >

            <ArrowLeft className="h-4 w-4" />

            Back to Airtime Portal

          </button>

          <h1 className="text-3xl font-black text-slate-900">

            Airtime Disbursement History

          </h1>

        </div>

        <div className="flex flex-wrap gap-3">

          <select

            value={size}

            onChange={(e) => {

              setSize(Number(e.target.value));

              setPage(0);

            }}

            className="rounded-2xl border border-slate-300 px-4 py-3 text-sm"

          >

            {[10, 20, 50].map((item) => (

              <option key={item} value={item}>

                {item} rows

              </option>

            ))}

          </select>

          <button

            type="button"

            disabled={mutation.isPending}

            onClick={() => mutation.mutate()}

            className="inline-flex items-center gap-2 rounded-2xl bg-emerald-600 px-6 py-3 font-black text-white hover:bg-emerald-700 disabled:opacity-50"

          >

            <Play className="h-4 w-4" />

            {mutation.isPending ? "Running..." : "Run Test Disbursement"}

          </button>

        </div>

      </div>

      {isFetching ? (

        <div className="mb-3 text-sm font-bold text-slate-500">Refreshing...</div>

      ) : null}

      <AirtimeBatchTable data={data?.content || []} />

      <div className="mt-5 flex justify-between rounded-3xl border border-slate-200 bg-white px-5 py-4 text-sm">

        <div className="font-semibold text-slate-600">

          Page {(data?.number ?? 0) + 1} of {data?.totalPages ?? 0} •{" "}

          {data?.totalElements ?? 0} record(s)

        </div>

        <div className="flex gap-2">

          <button

            disabled={page <= 0}

            onClick={() => setPage((current) => current - 1)}

            className="rounded-2xl border px-4 py-2 font-black disabled:opacity-40"

          >

            Previous

          </button>

          <button

            disabled={page + 1 >= (data?.totalPages ?? 0)}

            onClick={() => setPage((current) => current + 1)}

            className="rounded-2xl border px-4 py-2 font-black disabled:opacity-40"

          >

            Next

          </button>

        </div>

      </div>

    </div>

  );

}